import styled from 'styled-components';

export const Badge = styled.span`
  transform: translateY(1px);
  color: #055cf5;
  background-color: #eff7ff;
  font-size: 0.6em;
  padding: 2px 6px;
  border-radius: 6px;
  font-weight: 700;
  margin-right: 6px;
`;

export const ServiceBadge = styled.div`
  transform: translateY(1px);
  color: #62656a;
  background-color: #f3f4f8;
  font-size: 14px;
  padding: 7px 16px;
  border-radius: 16px;
  font-weight: 500;
  margin-right: 6px;
`;

export const ServiceMore = styled.div`
  line-height: 140.62%;
  text-decoration-line: underline;
  color: #2e3035;
  font-size: 14px;
  padding: 7px 0px;
  border-radius: 16px;
  font-weight: 500;
  margin-right: 6px;
  cursor: pointer;
`;
